import moment from 'moment-timezone';
import { EnterpriseDataCompletenessMetricStat } from './enterprise-data-completeness-metric-stat';

export class EnterpriseDataCompletenessMetrics {
	dataCompletenessGraph: { date: Date; countFullData: number; countPartialData: number; countNoneData: number }[];
	dataCompletenessStats: EnterpriseDataCompletenessMetricStat;

	constructor(enterpriseDataCompletenessMetrics?: EnterpriseDataCompletenessMetrics) {
		Object.assign(this, enterpriseDataCompletenessMetrics);

		this.dataCompletenessGraph = this.dataCompletenessGraph
		? this.dataCompletenessGraph.map(d => ({...d, date: new Date(moment(d.date).format('MMM DD, YYYY 00:00:00 a')) }))
		: [];
	}
}
